import type { CabinetSummary, SummaryBooked } from "@planerius/contracts/cabinet"

import { apiRequest } from "./http"

/**
 * Сводка владельца (5-В1) и её разборы (5-В2, 5-В3).
 *
 * ОДИН ЗАПРОС НА ВЕСЬ ЭКРАН, включая обе страницы разбора: строки загрузки и потерь —
 * это те же карточки, посчитанные тем же запросом. Отдельные запросы означали бы второй
 * расчёт по тем же таблицам и, рано или поздно, два разных числа в двух местах одного
 * экрана — «64 %» на сводке и «61 %» в её же разборе.
 *
 * ОТВЕТ НЕ ВАЛИДИРУЕТСЯ ZOD'ОМ. Сводка приходит целиком, со строками разбора, и разбор
 * схемы на телефоне администратора стоит дороже, чем ошибка, которую он поймал бы:
 * поля сюда приходят из того же контракта, что их и объявил.
 */
export function fetchSummary(
  params: { readonly date?: string; readonly branchId?: string },
  signal?: AbortSignal,
): Promise<CabinetSummary> {
  const query: Record<string, string> = {}
  if (params.date !== undefined) query["date"] = params.date
  if (params.branchId !== undefined) query["branchId"] = params.branchId
  return apiRequest("/cabinet/summary", { query, signal })
}

/**
 * 5-В4 «Записано» — отдельный запрос со своим периодом.
 *
 * Не поле сводки: расчёт по четырнадцати дням заметно дороже сводки за один день,
 * и платить за две недели каждый раз, когда владелец открывает сводку между двумя
 * клиентами, незачем.
 */
export function fetchBooked(
  params: { readonly days: number; readonly branchId?: string },
  signal?: AbortSignal,
): Promise<SummaryBooked> {
  const query: Record<string, string> = { days: String(params.days) }
  if (params.branchId !== undefined) query["branchId"] = params.branchId
  return apiRequest("/cabinet/summary/booked", { query, signal })
}
